import { useEffect } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { loadUser } from "./slices/userSlice";
import { getActiveRoles } from "./slices/roleSlice";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ChangePassword from "./pages/ChangePassword";
import RoleManagement from "./pages/RoleManagement";
import ProductManagement from "./pages/ProductManagement";
import UserManagement from "./pages/UserManagement";
import ContactManagement from "./pages/ContactManagement";
import PartyManagement from "./pages/PartyManagement";
import MyBusiness from "./pages/MyBusiness";
import PDFManagement from "./pages/PDFManagement";
import BillManagement from "./pages/BillManagement";
import PrivateRoute from "./componets/PrivateRoute";
import AdminRoute from "./componets/AdminRoute";
import WhatsAppControlPage from "./pages/WhatsApp/WhatsAppControlPage";

function App() {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.user);

  useEffect(() => {
    dispatch(loadUser());
  }, [dispatch]);

  useEffect(() => {
    // Load active roles when user is authenticated
    if (isAuthenticated) {
      dispatch(getActiveRoles());
    }
  }, [dispatch, isAuthenticated]);

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/my-business" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/whatsapp-control"
            element={
              <PrivateRoute>
                <WhatsAppControlPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/password/reset/:token" element={<ResetPassword />} />
          <Route
            path="/change-password"
            element={
              <PrivateRoute>
                <ChangePassword />
              </PrivateRoute>
            }
          />
          <Route
            path="/roles"
            element={
              <AdminRoute resource="roles" action="read">
                <RoleManagement />
              </AdminRoute>
            }
          />
          <Route
            path="/products"
            element={
              <AdminRoute resource="products" action="read">
                <ProductManagement />
              </AdminRoute>
            }
          />
          <Route
            path="/users"
            element={
              <AdminRoute resource="users" action="read">
                <UserManagement />
              </AdminRoute>
            }
          />
          <Route
            path="/contacts"
            element={
              <AdminRoute resource="contacts" action="read">
                <ContactManagement />
              </AdminRoute>
            }
          />
          <Route
            path="/parties"
            element={
              <AdminRoute resource="parties" action="read">
                <PartyManagement />
              </AdminRoute>
            }
          />
          <Route
            path="/my-business"
            element={
              <PrivateRoute>
                <MyBusiness />
              </PrivateRoute>
            }
          />
          <Route
            path="/pdfs"
            element={
              <AdminRoute resource="contacts" action="read">
                <PDFManagement />
              </AdminRoute>
            }
          />
          <Route
            path="/bills"
            element={
              <AdminRoute resource="parties" action="read">
                <BillManagement />
              </AdminRoute>
            }
          />
          <Route path="*" element={<Navigate to="/my-business" replace />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;
